export default __webpack_public_path__ + "static/18-63be507a14bbba0b28d7ac7535f29f23.jpg";